// client/src/config.js
const API_BASE_URL = '/api';

// URL del server comparatore
export const COMPARATOR_API_URL = '/comparatore-api';

export const WS_BASE_URL = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;

export default API_BASE_URL;
